import axiosInstance from "auth/FetchInterceptor";
import { GET_ALL_MATERIAL, GET_ALL_MATERIAL_V2, MATERIAL, MATERIAL_CATEGORY, MATERIAL_CATEGORY_TOOL, MATERIAL_CATEGORY_V2, MATERIAL_DETAIL, MATERIAL_DETAIL_V2, MATERIAL_UNIT, MATERIAL_UNIT_V2, MATERIAL_V2, SUPPLIER_URL, SYNC_MATERIAL_PARTNER } from "constants/ApiConstant";

const WarehouseService = {};

//Material Category
WarehouseService.getAllMaterialCategory = function (data) {
  return axiosInstance.get(`${MATERIAL_CATEGORY}/${data.storeId}`, null);
};
WarehouseService.createMaterialCategory = function (data) {
  return axiosInstance.post(MATERIAL_CATEGORY, data);
};
WarehouseService.updateMaterialCategory = function (data) {
  return axiosInstance.put(MATERIAL_CATEGORY, data);
};
WarehouseService.deleteMaterialCategory = function (id) {
  return axiosInstance.delete(`${MATERIAL_CATEGORY}/${id}`, null);
};

//Material
WarehouseService.getAllMaterial = function (data) {
  return axiosInstance.post(GET_ALL_MATERIAL, data);
};
WarehouseService.getMaterialDetail = function (data) {
  return axiosInstance.get(`${MATERIAL_DETAIL}/${data.id}`, null);
};
WarehouseService.createMaterial = function (data) {
  return axiosInstance.post(MATERIAL, data);
};
WarehouseService.updateMaterial = function (data) {
  return axiosInstance.put(MATERIAL, data);
};
WarehouseService.deleteMaterial = function (id) {
  return axiosInstance.delete(`${MATERIAL}/${id}`, null);
};
WarehouseService.deleteMultiMaterial = function (data) {
  return axiosInstance.delete(`${MATERIAL}/multi`, { data });
};

//Material Unit
WarehouseService.getAllMaterialUnit = function (data) {
  return axiosInstance.get(`${MATERIAL_UNIT}/${data.storeId}`, null);
};
WarehouseService.createMaterialUnit = function (data) {
  return axiosInstance.post(MATERIAL_UNIT, data);
};
WarehouseService.updateMaterialUnit = function (data) {
  return axiosInstance.put(MATERIAL_UNIT, data);
};
WarehouseService.deleteMaterialUnit = function (id) {
  return axiosInstance.delete(`${MATERIAL_UNIT}/${id}`, null);
};

//SUPPLIER
WarehouseService.getAllSupplier = function (data) {
  return axiosInstance.get(`${SUPPLIER_URL}/${data.storeId}`, null);
};

WarehouseService.createSupplier = function (data) {
  return axiosInstance.post(SUPPLIER_URL, data);
};

WarehouseService.updateSupplier = function (data) {
  return axiosInstance.put(SUPPLIER_URL, data);
};

WarehouseService.delSupplier = function (id) {
  return axiosInstance.delete(`${SUPPLIER_URL}/${id}`, null);
};

//MATERIAL CATEGORY V2
WarehouseService.getAllMaterialCategoryV2 = function (partnerId) {
  return axiosInstance.get(`${MATERIAL_CATEGORY_V2}/${partnerId}`, null);
};

WarehouseService.createMaterialCategoryV2 = function (data) {
  return axiosInstance.post(MATERIAL_CATEGORY_V2, data);
};

WarehouseService.updateMaterialCategoryV2 = function (data) {
  return axiosInstance.put(MATERIAL_CATEGORY_V2, data);
};

WarehouseService.deleteMaterialCategoryV2 = function (id) {
  return axiosInstance.delete(`${MATERIAL_CATEGORY_V2}/${id}`, null);
};

//MATERIAL CATEGORY TOOL
WarehouseService.getAllMaterialCategoryTool = function (id) {
  return axiosInstance.get(`${MATERIAL_CATEGORY_TOOL}/${id}`, null);
};


//MATERIAL V2
WarehouseService.getAllMaterialV2 = function (data) {
  return axiosInstance.post(GET_ALL_MATERIAL_V2, data);
};

WarehouseService.getMaterialDetailV2 = function (data) {
  return axiosInstance.get(`${MATERIAL_DETAIL_V2}/${data.id}`, null);
};

WarehouseService.createMaterialV2 = function (data) {
  return axiosInstance.post(MATERIAL_V2, data);
};

WarehouseService.updateMaterialV2 = function (data) {
  return axiosInstance.put(MATERIAL_V2, data);
};
//delete in old version

//MATERIAL UNIT V2
WarehouseService.getAllMaterialUnitV2 = function (partnerId) {
  return axiosInstance.get(`${MATERIAL_UNIT_V2}/${partnerId}`, null);
};

WarehouseService.createMaterialUnitV2 = function (data) {
  return axiosInstance.post(MATERIAL_UNIT_V2, data);
};

WarehouseService.updateMaterialUnitV2 = function (data) {
  return axiosInstance.put(MATERIAL_UNIT_V2, data);
};

WarehouseService.deleteMaterialUnitV2 = function (id) {
  return axiosInstance.delete(`${MATERIAL_UNIT_V2}/${id}`, null);
};

WarehouseService.syncMaterialPartner = function (data) {
  return axiosInstance.post(SYNC_MATERIAL_PARTNER, data);
};

export default WarehouseService;